import { createTheme, Theme } from '@mui/material/styles';
import { ColorTokens, DensityTokens } from './signatureTokens';

/**
 * Construtor soberano do tema MUI Galatea Signature.
 * Garante alinhamento total de tokens e componentes MUI.
 */
export function buildSignatureMuiTheme(colors: ColorTokens, densities: DensityTokens): Theme {
  return createTheme({
    palette: {
      mode: colors.bgApp.includes('0B') || colors.bgApp.includes('07') || colors.bgApp.includes('0F') ? 'dark' : 'light',
      primary: {
        main: colors.primary,
        light: colors.primaryLight,
        dark: colors.primaryHover,
      },
      secondary: {
        main: colors.accentIA,
      },
      background: {
        default: colors.bgApp,
        paper: colors.bgSurface,
      },
      text: {
        primary: colors.textPrimary,
        secondary: colors.textSecondary,
        disabled: colors.textMuted,
      },
      success: {
        main: colors.success,
      },
      warning: {
        main: colors.warning,
      },
      error: {
        main: colors.danger,
      },
      divider: colors.border,
    },
    typography: {
      fontFamily: ['Geist', 'Inter', '-apple-system', 'BlinkMacSystemFont', 'sans-serif'].join(','),
      fontSize: densities.fontSizeBasePx,
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: colors.bgApp,
            color: colors.textPrimary,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: colors.bgSurface,
            borderColor: colors.border,
            backgroundImage: 'none',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textTransform: 'none',
            fontWeight: 600,
            color: colors.textSecondary,
            '&.Mui-selected': {
              color: colors.primary,
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            textTransform: 'none',
            fontWeight: 700,
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: densities.fontSizeBasePx,
            minHeight: densities.inputMinHeightPx,
            backgroundColor: colors.bgSurface,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            '& fieldset': {
              borderColor: colors.border,
            },
            '&:hover fieldset': {
              borderColor: colors.primary,
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.primary,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderColor: colors.border,
            padding: densities.inputMinHeightPx <= 28 ? '6px 12px' : '12px 16px',
            fontSize: densities.fontSizeBasePx,
          },
          head: {
            fontWeight: 700,
            backgroundColor: colors.bgApp,
            color: colors.textSecondary,
          },
        },
      },
    },
  });
}
